$(document).ready(function () {
    $('.prepaid_container .dropdown').on('click', function (e) {
        e.preventDefault();

        if ($(this).find('.content').hasClass('hidden')) {
            $(this).find('.content').removeClass('hidden').addClass('show');
            $(this).css({ zIndex: '1', height: '325px' });
            $(this).find('.plus').removeClass('show').addClass('hidden');
            $(this).find('.minus').removeClass('hidden').addClass('show');
        } else {
            $(this).find('.content').removeClass('show').addClass('hidden');
            $(this).css({ zIndex: '0', height: '180px' });
            $(this).find('.plus').removeClass('hidden').addClass('show');
            $(this).find('.minus').removeClass('show').addClass('hidden');
        }
    });

    if ($(window).width() < 1250) {
        $(".prepaid_card_wrapper").slick({
            dots: false,
            prevArrow: false,
            nextArrow: false,
            centerMode: false,
            centerPadding: "60px",
            infinite: false,
            slidesToShow: 3,
            autoplay: true,
            autoplaySpeed: 1500,
            responsive: [
                {
                    breakpoint: 850,
                    settings: {
                        arrows: false,
                        variableWidth: true,
                        centerMode: true,
                        centerPadding: "40px",
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: "40px",
                        slidesToShow: 1,
                    },
                },
            ],
        });
    } else if ($(window).width() > 1249) {
        $(".prepaid_card_wrapper").slick("unslick");
    }

    $('.news-carousel').slick({
        // dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                // dots: true
            }
        },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    // infinite: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    if (!$('.prepaid_container').length) {
        return;
    }
    $('.more-info').on('click', function () {
        $('.popup').removeClass('more-info-popup-open-left', 'more-info-popup-close').addClass('more-info-popup-close')
        let popup = $(this).parents('.price').siblings('.popup')

        $('body').off('click')
        setTimeout(function () {
            $('body').not('.popup').on('click', function (e) {
                $(popup).attr('class', 'more-info-popup-close popup')
            })
        }, 500)

        if ($(popup).data('index') == 3) {
            $(popup).addClass('more-info-popup-open-left')
        } else {
            $(popup).addClass('more-info-popup-open')
        }
        $(popup).removeClass('more-info-popup-close')
    })

    $('.close-popup').on('click', function (e) {
        $('.popup').removeClass('more-info-popup-open-left', 'more-info-popup-close').addClass('more-info-popup-close')
    })
});
